export const en = {
  'shell.nav.equipment': 'Equipment',
  'shell.nav.maintenance': 'Maintenance',
  'enum.equipmentKind.CARDIO': 'Cardio',
  'enum.equipmentKind.STRENGTH': 'Strength',
  'enum.equipmentKind.FREE_WEIGHTS': 'Free weights',
  'enum.equipmentKind.OTHER': 'Other',
  'enum.equipmentStatus.IN_SERVICE': 'In service',
  'enum.equipmentStatus.OUT_OF_ORDER': 'Out of order',
  'enum.equipmentStatus.RETIRED': 'Retired',
  'enum.ticketPriority.LOW': 'Low',
  'enum.ticketPriority.NORMAL': 'Normal',
  'enum.ticketPriority.URGENT': 'Urgent',
  'enum.ticketStatus.OPEN': 'Open',
  'enum.ticketStatus.IN_PROGRESS': 'In progress',
  'enum.ticketStatus.RESOLVED': 'Resolved',
  'enum.ticketStatus.WONT_FIX': "Won't fix",

  'equipment.title': 'Equipment',
  'equipment.description': 'Every machine the gym owns, where it stands, what it cost and when it was last serviced.',
  'equipment.add': 'Add machine',
  'equipment.labels': 'Print labels',
  'equipment.labelsHint': 'One PDF with the label of every machine in this list, eight to a page.',
  'equipment.searchPlaceholder': 'Search by name, brand, model or serial number',
  'equipment.thisBranch': 'This branch',
  'equipment.allBranches': 'All branches',
  'equipment.anyKind': 'Any kind',
  'equipment.anyStatus': 'Any status',
  'equipment.clearFilters': 'Clear filters',
  'equipment.empty': 'No machines yet',
  'equipment.emptyHint': 'Add the gym’s machines to print their QR labels and keep track of faults and servicing.',
  'equipment.emptyBranch': 'No machines at this branch',
  'equipment.emptyBranchHint': 'Add one, or choose All branches to see the gym’s other machines.',
  'equipment.noMatch': 'No machines match',
  'equipment.noMatchHint': 'Try another search or clear the filters.',
  'equipment.col.machine': 'Machine',
  'equipment.col.place': 'Branch and room',
  'equipment.col.tickets': 'Open tickets',
  'equipment.openTickets': '{count} open',
  'equipment.kind': 'Kind',
  'equipment.branch': 'Branch',
  'equipment.room': 'Room',
  'equipment.noRoom': 'No room',
  'equipment.brand': 'Brand',
  'equipment.model': 'Model',
  'equipment.serialNumber': 'Serial number',
  'equipment.purchaseDate': 'Purchased',
  'equipment.warranty': 'Warranty',
  'equipment.warrantyUntil': 'Warranty until',
  'equipment.warranty.active': 'Until {date}',
  'equipment.warranty.ended': 'Ended {date}',
  'equipment.serviceEvery': 'Planned service',
  'equipment.everyDays': 'Every {days} days',
  'equipment.noInterval': 'Only when something breaks',
  'equipment.lastServicedOn': 'Last serviced',
  'equipment.nextService': 'Next service',
  'equipment.notes': 'Notes',
  'equipment.back': 'All equipment',
  'equipment.details': 'Details',
  'equipment.tickets': 'Maintenance history',
  'equipment.noTickets': 'No problems reported for this machine',
  'equipment.report': 'Report a problem',
  'equipment.label': 'Print QR label',
  'equipment.photo': 'Picture',
  'equipment.photo.upload': 'Upload a picture',
  'equipment.photo.replace': 'Replace picture',
  'equipment.photo.remove': 'Remove',
  'equipment.photo.saved': 'Picture saved',
  'equipment.photo.removed': 'Picture removed',
  'equipment.form.addTitle': 'Add a machine',
  'equipment.form.addDescription': 'The name staff will see on its label and when they report a problem.',
  'equipment.form.editTitle': 'Edit machine',
  'equipment.form.namePlaceholder': 'Treadmill 3',
  'equipment.form.nameRequired': 'Give the machine a name',
  'equipment.form.price': 'Price ({currency})',
  'equipment.form.interval': 'Service every (days)',
  'equipment.form.intervalHint': 'Leave empty for no planned service',
  'equipment.form.lastServicedHint': 'Service counts from here, or from the purchase',
  'equipment.form.created': 'Machine added',
  'equipment.form.saved': 'Machine saved',

  'report.title': 'Report a problem',
  'report.quick': 'What is wrong?',
  'report.quick.wontStart': 'Will not start.',
  'report.quick.noise': 'Strange noise.',
  'report.quick.display': 'Display not working.',
  'report.quick.worn': 'Belt, cable or pad is worn.',
  'report.description': 'Describe the problem',
  'report.descriptionPlaceholder': 'What did you see or hear?',
  'report.priority': 'How urgent is it?',
  'report.outOfOrder': 'Mark the machine out of order',
  'report.outOfOrderHint': 'Everyone will see it is not to be used until a manager puts it back.',
  'report.photo': 'Picture',
  'report.photoFailed': 'The report was sent, but the picture could not be uploaded',
  'report.send': 'Send report',
  'report.sent': 'Thank you, the problem is reported',
  'report.sentHint': 'A manager will see it on the maintenance board.',
  'report.another': 'Report another problem',
  'report.toMachine': 'Open the machine',
  'report.retired': 'This machine has been retired, so problems can no longer be reported for it.',

  'maintenance.title': 'Maintenance',
  'maintenance.description': 'Reported problems and planned services, from open to resolved.',
  'maintenance.board': 'Tickets by status',
  'maintenance.searchPlaceholder': 'Search by problem or machine',
  'maintenance.anyPriority': 'Any priority',
  'maintenance.anyone': 'Anyone',
  'maintenance.mine': 'Assigned to me',
  'maintenance.unassigned': 'Unassigned',
  'maintenance.columnEmpty': 'Nothing here',
  'maintenance.more': 'Showing {shown} of {total}',
  'maintenance.planned': 'Planned service due {date}',

  'ticket.back': 'Maintenance board',
  'ticket.details': 'The problem',
  'ticket.manage': 'Handling',
  'ticket.assignee': 'Assigned to',
  'ticket.priority': 'Priority',
  'ticket.cost': 'Cost ({currency})',
  'ticket.photo': 'Picture of the problem',
  'ticket.saved': 'Ticket saved',
  'ticket.reportedBy': 'Reported by {name} on {date}',
  'ticket.openedByJob': 'Opened by the daily service check on {date}',
  'ticket.plannedFor': 'Service due on {date}',
  'ticket.resolution': 'Resolution',
  'ticket.closedBy': 'Closed by {name} on {date}',
  'ticket.start': 'Start work',
  'ticket.backToOpen': 'Back to open',
  'ticket.resolve': 'Resolve',
  'ticket.wontFix': "Won't fix",
  'ticket.reopen': 'Reopen',
  'ticket.moved': 'Ticket is now {status}',
  'ticket.timeline': 'Timeline',
  'ticket.close.resolveTitle': 'Resolve: {machine}',
  'ticket.close.wontFixTitle': "Won't fix: {machine}",
  'ticket.close.note': 'What was done',
  'ticket.close.notePlaceholder': 'Replaced the belt…',
  'ticket.close.reason': 'Why it will not be fixed',
  'ticket.close.reasonPlaceholder': 'Cosmetic only, scrapped…',
  'ticket.close.returnToService': 'Put the machine back in service',
  'ticket.close.returnToServiceHint': 'It is out of order and this is its last open ticket.',
  'ticket.close.stillOpen': 'Other tickets are still open on this machine ({count}), so it stays out of order.',
  'ticket.close.recordedCost': 'Cost so far: {amount}',
  'ticket.note.title': 'Add a note',
  'ticket.note.text': 'Note',
  'ticket.note.placeholder': 'Anything the next person should know',
  'ticket.note.save': 'Add note',
  'ticket.note.saved': 'Note added',
  'ticket.field.description': 'description',
  'ticket.field.priority': 'priority',
  'ticket.field.costMinor': 'cost',
  'ticket.event.CREATED': 'Reported ({priority})',
  'ticket.event.CREATED.planned': 'Opened for the planned service due {date}',
  'ticket.event.STATUS_CHANGED': '{from} → {to}',
  'ticket.event.ASSIGNED': 'Assigned to {name}',
  'ticket.event.unassigned': 'Unassigned',
  'ticket.event.UPDATED': 'Changed: {fields}',
  'ticket.event.NOTE': 'Note',
  'ticket.event.EQUIPMENT_STATUS.OUT_OF_ORDER': 'Machine taken out of order',
  'ticket.event.EQUIPMENT_STATUS.IN_SERVICE': 'Machine back in service',
  'ticket.event.cost': 'Cost {amount}',
  'ticket.event.system': 'Daily service check',
  'ticket.expense.log': 'Log as expense',
  'ticket.expense.logged': 'Logged as an expense',
  'ticket.expense.title': 'Log the cost as an expense',
  'ticket.expense.description': 'One expense of {amount} in Maintenance at the machine’s branch, dated the day the ticket was resolved.',
  'ticket.expense.method': 'Paid by',
  'ticket.expense.note': 'Note',
  'ticket.expense.done': 'Expense logged',

  'admin.apiError.NO_EQUIPMENT': 'No machine matches these filters, so there are no labels to print.',
  'admin.apiError.TOO_MANY_LABELS': 'At most {max} labels print at once. Narrow the list with a filter and try again.',
  'admin.apiError.TICKET_NOT_RESOLVED': 'The cost can be logged as an expense once the ticket is resolved.',
  'admin.apiError.NO_COST': 'Record what the work cost on the ticket first.',
  'admin.apiError.ROOM_NOT_IN_BRANCH': 'That room belongs to another branch.',
  'admin.apiError.EQUIPMENT_RETIRED': 'This machine has been retired.',
  'admin.apiError.OUT_OF_ORDER_URGENT_ONLY': 'Only an urgent problem takes a machine out of order.',
  'admin.apiError.TICKET_STATUS_NOT_ALLOWED': 'The ticket cannot move to that status from where it is.',
  'admin.apiError.RESOLUTION_NOTE_REQUIRED': 'Say why this will not be fixed.',
  'admin.apiError.TICKET_ASSIGNEE_NOT_ALLOWED': 'A ticket can be given only to staff of this gym.',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.equipment': 'აღჭურვილობა',
  'shell.nav.maintenance': 'ტექნიკური მომსახურება',
  'enum.equipmentKind.CARDIO': 'კარდიო',
  'enum.equipmentKind.STRENGTH': 'ძალისმიერი',
  'enum.equipmentKind.FREE_WEIGHTS': 'თავისუფალი წონები',
  'enum.equipmentKind.OTHER': 'სხვა',
  'enum.equipmentStatus.IN_SERVICE': 'მუშაობს',
  'enum.equipmentStatus.OUT_OF_ORDER': 'გაუმართავია',
  'enum.equipmentStatus.RETIRED': 'ჩამოწერილია',
  'enum.ticketPriority.LOW': 'დაბალი',
  'enum.ticketPriority.NORMAL': 'ჩვეულებრივი',
  'enum.ticketPriority.URGENT': 'სასწრაფო',
  'enum.ticketStatus.OPEN': 'ღიაა',
  'enum.ticketStatus.IN_PROGRESS': 'მიმდინარეობს',
  'enum.ticketStatus.RESOLVED': 'მოგვარებულია',
  'enum.ticketStatus.WONT_FIX': 'არ გასწორდება',

  'equipment.title': 'აღჭურვილობა',
  'equipment.description': 'ყველა ტრენაჟორი, რომელიც დარბაზს ეკუთვნის: სად დგას, რა დაჯდა და როდის მომსახურდა ბოლოს.',
  'equipment.add': 'ტრენაჟორის დამატება',
  'equipment.labels': 'ეტიკეტების ბეჭდვა',
  'equipment.labelsHint': 'ერთი PDF სიაში ნაჩვენები ყველა ტრენაჟორის ეტიკეტით, თითო გვერდზე რვა ეტიკეტი.',
  'equipment.searchPlaceholder': 'ძებნა სახელით, ბრენდით, მოდელით ან სერიული ნომრით',
  'equipment.thisBranch': 'ეს ფილიალი',
  'equipment.allBranches': 'ყველა ფილიალი',
  'equipment.anyKind': 'ნებისმიერი ტიპი',
  'equipment.anyStatus': 'ნებისმიერი სტატუსი',
  'equipment.clearFilters': 'ფილტრების გასუფთავება',
  'equipment.empty': 'ტრენაჟორები ჯერ არ არის',
  'equipment.emptyHint': 'დაამატეთ დარბაზის ტრენაჟორები, რომ დაბეჭდოთ QR ეტიკეტები და აკონტროლოთ დაზიანებები და მომსახურება.',
  'equipment.emptyBranch': 'ამ ფილიალში ტრენაჟორები ჯერ არ არის',
  'equipment.emptyBranchHint': 'დაამატეთ ტრენაჟორი ან აირჩიეთ „ყველა ფილიალი“, რომ დარბაზის სხვა ტრენაჟორებიც ნახოთ.',
  'equipment.noMatch': 'ტრენაჟორი ვერ მოიძებნა',
  'equipment.noMatchHint': 'სცადეთ სხვა საძიებო სიტყვა ან გაასუფთავეთ ფილტრები.',
  'equipment.col.machine': 'ტრენაჟორი',
  'equipment.col.place': 'ფილიალი და ოთახი',
  'equipment.col.tickets': 'ღია განაცხადები',
  'equipment.openTickets': '{count} ღიაა',
  'equipment.kind': 'ტიპი',
  'equipment.branch': 'ფილიალი',
  'equipment.room': 'ოთახი',
  'equipment.noRoom': 'ოთახის გარეშე',
  'equipment.brand': 'ბრენდი',
  'equipment.model': 'მოდელი',
  'equipment.serialNumber': 'სერიული ნომერი',
  'equipment.purchaseDate': 'შეძენის თარიღი',
  'equipment.warranty': 'გარანტია',
  'equipment.warrantyUntil': 'გარანტია მოქმედებს',
  'equipment.warranty.active': '{date}-მდე',
  'equipment.warranty.ended': 'დასრულდა {date}',
  'equipment.serviceEvery': 'დაგეგმილი მომსახურება',
  'equipment.everyDays': 'ყოველ {days} დღეში',
  'equipment.noInterval': 'მხოლოდ გაფუჭებისას',
  'equipment.lastServicedOn': 'ბოლო მომსახურება',
  'equipment.nextService': 'შემდეგი მომსახურება',
  'equipment.notes': 'შენიშვნები',
  'equipment.back': 'მთელი აღჭურვილობა',
  'equipment.details': 'დეტალები',
  'equipment.tickets': 'მომსახურების ისტორია',
  'equipment.noTickets': 'ამ ტრენაჟორზე პრობლემა არ შეუტყობინებიათ',
  'equipment.report': 'პრობლემის შეტყობინება',
  'equipment.label': 'QR ეტიკეტის ბეჭდვა',
  'equipment.photo': 'ფოტო',
  'equipment.photo.upload': 'ფოტოს ატვირთვა',
  'equipment.photo.replace': 'ფოტოს შეცვლა',
  'equipment.photo.remove': 'წაშლა',
  'equipment.photo.saved': 'ფოტო შენახულია',
  'equipment.photo.removed': 'ფოტო წაშლილია',
  'equipment.form.addTitle': 'ტრენაჟორის დამატება',
  'equipment.form.addDescription': 'სახელი, რომელსაც თანამშრომლები ეტიკეტზე და პრობლემის შეტყობინებისას დაინახავენ.',
  'equipment.form.editTitle': 'ტრენაჟორის რედაქტირება',
  'equipment.form.namePlaceholder': 'სარბენი ბილიკი 3',
  'equipment.form.nameRequired': 'მიუთითეთ ტრენაჟორის სახელი',
  'equipment.form.price': 'ფასი ({currency})',
  'equipment.form.interval': 'მომსახურება ყოველ (დღე)',
  'equipment.form.intervalHint': 'დატოვეთ ცარიელი, თუ დაგეგმილი მომსახურება არ სჭირდება',
  'equipment.form.lastServicedHint': 'მომსახურება ამ თარიღიდან ითვლება, ან შეძენიდან',
  'equipment.form.created': 'ტრენაჟორი დაემატა',
  'equipment.form.saved': 'ტრენაჟორი შენახულია',

  'report.title': 'პრობლემის შეტყობინება',
  'report.quick': 'რა მოხდა?',
  'report.quick.wontStart': 'არ ირთვება.',
  'report.quick.noise': 'უცნაური ხმაური.',
  'report.quick.display': 'ეკრანი არ მუშაობს.',
  'report.quick.worn': 'ლენტი, ტროსი ან ბალიში ცვდება.',
  'report.description': 'აღწერეთ პრობლემა',
  'report.descriptionPlaceholder': 'რა დაინახეთ ან რა გაიგონეთ?',
  'report.priority': 'რამდენად სასწრაფოა?',
  'report.outOfOrder': 'ტრენაჟორის გაუმართავად მონიშვნა',
  'report.outOfOrderHint': 'ყველა დაინახავს, რომ მისი გამოყენება არ შეიძლება, სანამ მენეჯერი არ დააბრუნებს.',
  'report.photo': 'ფოტო',
  'report.photoFailed': 'შეტყობინება გაიგზავნა, მაგრამ ფოტოს ატვირთვა ვერ მოხერხდა',
  'report.send': 'შეტყობინების გაგზავნა',
  'report.sent': 'გმადლობთ, პრობლემა დაფიქსირდა',
  'report.sentHint': 'მენეჯერი მას მომსახურების დაფაზე დაინახავს.',
  'report.another': 'სხვა პრობლემის შეტყობინება',
  'report.toMachine': 'ტრენაჟორის გვერდი',
  'report.retired': 'ეს ტრენაჟორი ჩამოწერილია, ამიტომ მასზე პრობლემის შეტყობინება აღარ შეიძლება.',

  'maintenance.title': 'ტექნიკური მომსახურება',
  'maintenance.description': 'შეტყობინებული პრობლემები და დაგეგმილი მომსახურება, გახსნიდან მოგვარებამდე.',
  'maintenance.board': 'განაცხადები სტატუსის მიხედვით',
  'maintenance.searchPlaceholder': 'ძებნა პრობლემით ან ტრენაჟორით',
  'maintenance.anyPriority': 'ნებისმიერი პრიორიტეტი',
  'maintenance.anyone': 'ყველა',
  'maintenance.mine': 'ჩემზე მიბმული',
  'maintenance.unassigned': 'მიუბმელი',
  'maintenance.columnEmpty': 'აქ არაფერია',
  'maintenance.more': 'ნაჩვენებია {shown} / {total}',
  'maintenance.planned': 'დაგეგმილი მომსახურების ვადა: {date}',

  'ticket.back': 'მომსახურების დაფა',
  'ticket.details': 'პრობლემა',
  'ticket.manage': 'დამუშავება',
  'ticket.assignee': 'პასუხისმგებელი',
  'ticket.priority': 'პრიორიტეტი',
  'ticket.cost': 'ღირებულება ({currency})',
  'ticket.photo': 'პრობლემის ფოტო',
  'ticket.saved': 'განაცხადი შენახულია',
  'ticket.reportedBy': 'შეატყობინა {name}, {date}',
  'ticket.openedByJob': 'გახსნა ყოველდღიურმა შემოწმებამ, {date}',
  'ticket.plannedFor': 'მომსახურების ვადა: {date}',
  'ticket.resolution': 'შედეგი',
  'ticket.closedBy': 'დახურა {name}, {date}',
  'ticket.start': 'მუშაობის დაწყება',
  'ticket.backToOpen': 'ღიად დაბრუნება',
  'ticket.resolve': 'მოგვარება',
  'ticket.wontFix': 'არ გასწორდება',
  'ticket.reopen': 'ხელახლა გახსნა',
  'ticket.moved': 'განაცხადის სტატუსია: {status}',
  'ticket.timeline': 'ისტორია',
  'ticket.close.resolveTitle': 'მოგვარება: {machine}',
  'ticket.close.wontFixTitle': 'არ გასწორდება: {machine}',
  'ticket.close.note': 'რა გაკეთდა',
  'ticket.close.notePlaceholder': 'ლენტი შეიცვალა…',
  'ticket.close.reason': 'რატომ არ გასწორდება',
  'ticket.close.reasonPlaceholder': 'მხოლოდ გარეგნული ნაკლია, ჩამოიწერა…',
  'ticket.close.returnToService': 'ტრენაჟორის ექსპლუატაციაში დაბრუნება',
  'ticket.close.returnToServiceHint': 'ის გაუმართავია და ეს მისი ბოლო ღია განაცხადია.',
  'ticket.close.stillOpen': 'ამ ტრენაჟორზე სხვა განაცხადებიც ღიაა ({count}), ამიტომ ის გაუმართავი რჩება.',
  'ticket.close.recordedCost': 'ღირებულება ამჟამად: {amount}',
  'ticket.note.title': 'შენიშვნის დამატება',
  'ticket.note.text': 'შენიშვნა',
  'ticket.note.placeholder': 'რაც მომდევნო ადამიანმა უნდა იცოდეს',
  'ticket.note.save': 'შენიშვნის დამატება',
  'ticket.note.saved': 'შენიშვნა დაემატა',
  'ticket.field.description': 'აღწერა',
  'ticket.field.priority': 'პრიორიტეტი',
  'ticket.field.costMinor': 'ღირებულება',
  'ticket.event.CREATED': 'შეტყობინება ({priority})',
  'ticket.event.CREATED.planned': 'გაიხსნა დაგეგმილი მომსახურებისთვის, ვადა: {date}',
  'ticket.event.STATUS_CHANGED': '{from} → {to}',
  'ticket.event.ASSIGNED': 'პასუხისმგებელი: {name}',
  'ticket.event.unassigned': 'მიბმა მოიხსნა',
  'ticket.event.UPDATED': 'შეიცვალა: {fields}',
  'ticket.event.NOTE': 'შენიშვნა',
  'ticket.event.EQUIPMENT_STATUS.OUT_OF_ORDER': 'ტრენაჟორი გაუმართავად მოინიშნა',
  'ticket.event.EQUIPMENT_STATUS.IN_SERVICE': 'ტრენაჟორი ექსპლუატაციაში დაბრუნდა',
  'ticket.event.cost': 'ღირებულება: {amount}',
  'ticket.event.system': 'ყოველდღიური შემოწმება',
  'ticket.expense.log': 'ხარჯად აღრიცხვა',
  'ticket.expense.logged': 'აღრიცხულია ხარჯად',
  'ticket.expense.title': 'ღირებულების ხარჯად აღრიცხვა',
  'ticket.expense.description': 'ერთი ხარჯი {amount} ოდენობით ტექნიკური მომსახურების კატეგორიაში, ტრენაჟორის ფილიალზე, განაცხადის მოგვარების დღის თარიღით.',
  'ticket.expense.method': 'გადახდის მეთოდი',
  'ticket.expense.note': 'შენიშვნა',
  'ticket.expense.done': 'ხარჯი აღირიცხა',

  'admin.apiError.NO_EQUIPMENT': 'ამ ფილტრებით ტრენაჟორი ვერ მოიძებნა, ამიტომ დასაბეჭდი ეტიკეტები არ არის.',
  'admin.apiError.TOO_MANY_LABELS': 'ერთდროულად მაქსიმუმ {max} ეტიკეტის დაბეჭდვა შეიძლება. შეავიწროვეთ სია ფილტრით და სცადეთ თავიდან.',
  'admin.apiError.TICKET_NOT_RESOLVED': 'ღირებულების ხარჯად აღრიცხვა განაცხადის მოგვარების შემდეგ შეიძლება.',
  'admin.apiError.NO_COST': 'ჯერ განაცხადში მიუთითეთ, რა დაჯდა სამუშაო.',
  'admin.apiError.ROOM_NOT_IN_BRANCH': 'ეს ოთახი სხვა ფილიალს ეკუთვნის.',
  'admin.apiError.EQUIPMENT_RETIRED': 'ეს ტრენაჟორი ჩამოწერილია.',
  'admin.apiError.OUT_OF_ORDER_URGENT_ONLY': 'ტრენაჟორს გაუმართავად მხოლოდ სასწრაფო პრობლემა ხდის.',
  'admin.apiError.TICKET_STATUS_NOT_ALLOWED': 'განაცხადი ამჟამინდელი სტატუსიდან ამ სტატუსზე ვერ გადავა.',
  'admin.apiError.RESOLUTION_NOTE_REQUIRED': 'მიუთითეთ, რატომ არ გასწორდება.',
  'admin.apiError.TICKET_ASSIGNEE_NOT_ALLOWED': 'განაცხადი მხოლოდ ამ დარბაზის თანამშრომელზე შეიძლება მიემაგროს.',
};
